import React from "react";
import { Input } from "./Input.style";

export default function Searchbar() {
 return <Input type="text" placeholder="search..." />;
}
